import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

export class StudyAsset {
    assetId: string;
    assetClassCode: string;
    assetSubclassCode: string;
    circuit: string;
    prid: string;
    neighborhoodId: string;
    effectiveAge: number;
    oitYear: number;
    aitYear: number;
    fitYear: number;
    healthIndex: string;
    sensitivityCic: string;
    sensitivityInsp: string;
}

export class AssetHealthIndex {
    info: {
        assetId: string;
        assetClass: string;
        assetSubclass: string;
        methodology: string;
    };
    resultsFinal: {
        minScore: number;
        maxScore: number;
        totalScore: number;
        gatewayMultiplier: number;
        hi: number;
        dataAvailability: number;
        dataUnavailability: number;
        dataValidity: number;
        availTotalScore: number;
        validTotalScore: number;
        availValidMaxScore: number;
        normalizeRequired: string;
        lowScorePoor: string;
    };
    resultsDetail: DegradationFactor[];
    gateway: GatewayDetails;
    hazardRate: number[];
    history: AssetHistoryItem[];
}

export class GatewayDetails {
    gatewayComparison: string;
    gatewayCondition: string;
    gatewayFactor: string;
    gatewayMultiplier: number;
}

export class DegradationFactor {
    degNum: number;
    degWeight: number;
    degradation: number;
    degFactor: string;
    degFactorScoring: string;

    inspValueStr: string;
    inspValueNumeric: number;
    dataAvailable: boolean;
    dataValid: boolean;

    score: string;
    numericScore: number;
    numericScoreMin: number;
    numericScoreMax: number;
    weightedScore: number;
    weightedScoreMin: number;
    weightedScoreMax: number;
    possibleValues: DegradationFactorScoring[];
}

export class DegradationFactorScoring {
    score: string;
    value?: string;
    lowerBound?: number;
    upperBound?: number;
}

export class AssetHistoryItem {
    date: string;
    healthIndex: number;
}

export class AssetSensitivityData {
    shapeExisting: number;
    shapeNew: number;
    scaleExisting: number;
    scaleNew: number;
    impactExisting: number;
    impactNew: number;
    maintenanceExisting: number;
    maintenanceNew: number;
    intCost: number;
    existingAsset: any[];
    newAsset: any[];
    intType: string;
    scenarioKey: number;
}

export abstract class AssetsService {
    // Study Assets
    abstract getStudyAssetsDataSource(studyId: string): Observable<DataSource>;

    abstract searchStudyAssets(studyId: string, assetName: string): Observable<string[]>;

    abstract getStudyAsset(studyId: string, assetId: string): Observable<StudyAsset>;

    // Asset Details
    abstract getAssetDetails(studyId: string, assetId: string): Observable<any>;

    abstract getAssetDetailsHealthIndex(studyId: string, assetId: string): Observable<AssetHealthIndex>;
}
